// extracted by mini-css-extract-plugin
export default {"navigation":"CarouselNavigation_navigation__ZXMr-"};